/**
 * Root reducer,
 *  - router comes from react-router state
 *  - auth is cognito/auth related state
 *  - api is super.AI API related state
 *  - client is UI related state
 *
 * Redux thunk is utilised to help provide access to dispatch
 * and state access from within action creators
 */

import { ThunkAction, ThunkDispatch } from "redux-thunk"
import {
    connectRouter,
    RouterState,
    RouterAction
} from "connected-react-router"
import { History } from "history"
import { combineReducers } from "redux"
import { AuthReducer, AuthState, AuthAction } from "./Auth"
import { APIReducer, APIState, APIAction } from "./API"
import { ClientReducer, ClientState, ClientAction } from "./Client"
import { ExternalState, ExternalReducer, ExternalAction } from "./External"
import { TrackingAction } from "./External/TrackingReducer"

export type MainAction =
    | APIAction
    | AuthAction
    | RouterAction
    | ClientAction
    | ExternalAction
    | TrackingAction
export type MainThunkResult<R> = ThunkAction<R, State, undefined, MainAction>
export type MainThunkDispatch = ThunkDispatch<State, undefined, MainAction>

export interface State {
    router: RouterState
    auth: AuthState
    api: APIState
    client: ClientState
    external: ExternalState
}

export const rootReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history),
        auth: AuthReducer,
        api: APIReducer,
        client: ClientReducer,
        external: ExternalReducer
    })
